import { render, staticRenderFns } from "./UserMarketTiers.vue?vue&type=template&id=8b6e226c&scoped=true&"
import script from "./UserMarketTiers.vue?vue&type=script&lang=js&"
export * from "./UserMarketTiers.vue?vue&type=script&lang=js&"
import style0 from "./UserMarketTiers.vue?vue&type=style&index=0&id=8b6e226c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e226c",
  null
  
)

export default component.exports